module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/vivanuncios_mobile.2f6150ea.svg";